// @core/api/endpoints/billing/get_billing_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetBillingProductResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get product by ID
 * Retrieves a product by its unique identifier. Returns the product details including name, description, and unit information.
 */
export async function GetBillingProduct(
  id: string,
  options?: RequestOptions
): Promise<GetBillingProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetBillingProductResponse>(requestPath, { ...requestOptions });
}
